var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"alternate"}},[_c('h4',[_vm._v(_vm._s(_vm.first)+"?"),_c('strong',{on:{"click":_vm.redirectTo}},[_vm._v(_vm._s(_vm.second))])])])}
var staticRenderFns = []

export { render, staticRenderFns }